import { Link } from 'react-router-dom';
import { HiArrowUpRight } from 'react-icons/hi2';
import './MegaMenu.css';

export const MegaMenuMobile = ({ menu, isOpen, onNavigate }) => {
  if (!isOpen || !menu) {
    return null;
  }

  return (
    <div className="mega-menu-mobile">
      {menu.url ? (
        <Link to={menu.url} className="mega-menu-mobile__heading" onClick={onNavigate}>
          {menu.title}
          <HiArrowUpRight className="mega-menu-mobile__heading-icon" aria-hidden="true" />
        </Link>
      ) : (
        <p className="mega-menu-mobile__heading mega-menu-mobile__heading--static">
          {menu.title}
        </p>
      )}
      <p className="mega-menu-mobile__text">{menu.description}</p>

      <ul className="mega-menu-mobile__list">
        {menu.items.map((item) => (
          <li key={`${item.to}-${item.title}`}>
            <Link to={item.to} className="mega-menu-mobile__item" onClick={onNavigate}>
              <img
                className="mega-menu-mobile__item-icon"
                src={item.icon}
                alt=""
                aria-hidden="true"
                width="24"
                height="24"
              />
              <span className="mega-menu-mobile__item-body">
                <span className="mega-menu-mobile__item-title">{item.title}</span>
                <span className="mega-menu-mobile__item-subtitle">{item.subtitle}</span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

const MegaMenu = ({ menu, isOpen, onMouseEnter, onMouseLeave, onNavigate }) => {
  if (!menu) {
    return null;
  }

  return (
    <div
      className={`mega-menu ${isOpen ? 'mega-menu--open' : ''}`}
      aria-hidden={!isOpen}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="mega-menu__inner">
        <div className="mega-menu__intro">
          {menu.url ? (
            <Link to={menu.url} className="mega-menu__heading" onClick={onNavigate}>
              {menu.title}
              <HiArrowUpRight className="mega-menu__heading-icon" aria-hidden="true" />
            </Link>
          ) : (
            <p className="mega-menu__heading mega-menu__heading--static">{menu.title}</p>
          )}
          <p className="mega-menu__text">{menu.description}</p>
        </div>

        <div className="mega-menu__divider" />

        <div className="mega-menu__grid">
          {menu.items.map((item) => (
            <Link
              key={`${item.to}-${item.title}`}
              to={item.to}
              className="mega-menu__item"
              onClick={onNavigate}
            >
              <img
                className="mega-menu__item-icon"
                src={item.icon}
                alt=""
                aria-hidden="true"
                width="24"
                height="24"
              />
              <span className="mega-menu__item-body">
                <span className="mega-menu__item-title">{item.title}</span>
                <span className="mega-menu__item-subtitle">{item.subtitle}</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MegaMenu;
